module.exports = __webpack_public_path__ + "img/empty-post.b7a514a0.svg";